import { call, put, takeLatest } from 'redux-saga/effects';

import * as sliderActions from './sliderActions.js';
import { updateSliderApiCall } from './sliderAPI.js';

function* updateSliderSaga({ payload }) {
  try {
    const { data } = yield call(updateSliderApiCall, payload);
    yield put(sliderActions.sliderUpdateStore(data));
  } catch (error) {
    yield put(sliderActions.sliderUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* sliderWatcher() {
  yield takeLatest(sliderActions.sliderUpdateRequest.type, updateSliderSaga);
}
